import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../hooks/useTranslation';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <section className="py-24 min-h-[60vh] bg-black/90 text-white relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto bg-gradient-to-r from-neon-green/10 to-neon-cyan/10 backdrop-blur-xl border border-neon-green/30 rounded-3xl p-10 shadow-2xl shadow-neon-green/10"
        >
          <h1 className="text-4xl font-black text-neon-green mb-6">{t('privacy.title')}</h1>
          <p className="text-white/80 mb-4">
            {t('privacy.intro')}
          </p>
          <h2 className="text-2xl font-bold text-neon-cyan mt-8 mb-4">{t('privacy.infoTitle')}</h2>
          <ul className="list-disc list-inside text-white/70 mb-4">
            <li>{t('privacy.info1')}</li>
            <li>{t('privacy.info2')}</li>
          </ul>
          <h2 className="text-2xl font-bold text-neon-cyan mt-8 mb-4">{t('privacy.useTitle')}</h2>
          <ul className="list-disc list-inside text-white/70 mb-4">
            <li>{t('privacy.use1')}</li>
            <li>{t('privacy.use2')}</li>
            <li>{t('privacy.use3')}</li>
          </ul>
          <h2 className="text-2xl font-bold text-neon-cyan mt-8 mb-4">{t('privacy.contactTitle')}</h2>
          <p className="text-white/80">
            {t('privacy.contactText')}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PrivacyPolicy; 